import { useColorScheme } from "@mui/material/styles";

import { resolveColor, type ValidColor } from "./colors";

/**
 * Resolve a named colour to a concrete string for the *active* colour scheme.
 *
 * MUI's CSS variables already cover styling through `sx` and `theme.vars`. This hook
 * is for the places that cannot read a CSS variable — inline SVG `fill`/`stop-color`,
 * canvas contexts, and values handed to third-party widgets.
 *
 * @example
 *   const stroke = useColor("accent");    // semantic token, follows the scheme
 *   const grid = useColor("silver300");   // static primitive, same in both
 */
export function useColor(color?: ValidColor): string {
  const { mode, systemMode } = useColorScheme();
  const scheme = (mode === "system" ? systemMode : mode) ?? "light";
  return resolveColor(color, scheme);
}

/** The resolved colour scheme, with `system` collapsed to a concrete value. */
export function useResolvedScheme(): "light" | "dark" {
  const { mode, systemMode } = useColorScheme();
  return (mode === "system" ? systemMode : mode) ?? "light";
}
